import { sortBy } from "lodash";
import { APPOINTMENT } from "../util/constants";

const formatDropdownSubtypeFromState = (values) => {
  const { subtype, dropdowns: dropdownOptions } = values
  let optionState = {
    options: [],
    loading: false,
  };

  const relevantFields = dropdownOptions?.[subtype]
  if(relevantFields) {
    optionState = {
      options: Array.isArray(relevantFields.options)
      ? relevantFields.options
      : [],
      subtype,
      queries: relevantFields?.queries,
      status: relevantFields?.status,
      loading: relevantFields?.status === "loading",
    }
  }

  return optionState;
};

export const constructFacultyFields = (faculty = {}) => {
  const { emplid, facultyType, program, category, nameN } = faculty
  
  const identifier = [emplid, program, category].filter(item => !!item);
  if(identifier?.length) {
    let fields = { id: "", title: "" };
    const categoryDisplay = APPOINTMENT.CATEGORY[category];
    const facultyName = buildFacultyName(faculty);
    const facultyTypeDisplay = APPOINTMENT.FACULTY_TYPE[facultyType];
    
    fields.id = identifier.join("-");
    fields.title = (facultyName || "");
    if(fields.title && nameN) fields.title += ` (${nameN})`;
    if(fields.title && program) fields.title += ` - ${program}`;
    if(fields.title && categoryDisplay) fields.title += ` - Category ${categoryDisplay}`;
    if(fields.title && facultyTypeDisplay) fields.title += ` - ${facultyTypeDisplay}`;

    return fields;
  }

  return {}
}

export const buildFacultyName = (faculty) => {
  let name = ''
  if(faculty?.firstName) name += faculty.firstName
  if(faculty?.middleInitial) name += ` ${faculty.middleInitial}`
  if(faculty?.lastName) name += ` ${faculty.lastName}`
  return name
};
const transformGraduateFacultyDropdownOptions = (graduateFaculty = [], skipGrouping = false) => {
  if(skipGrouping) {
    return graduateFaculty
  }
  const options = [];
  for(const faculty of graduateFaculty) {
    for(const appointment of (faculty.appointments ?? [])) {
      const category = appointment.category;
      const categoryDisplay = APPOINTMENT.CATEGORY[category];
      const program = appointment.program;
      if(program && categoryDisplay) {
        const value = { 
          emplid: faculty.emplid,
          firstName: faculty.firstName,
          lastName: faculty.lastName,
          middleName: faculty.middleInitial,
          facultyEmail: faculty.email,
          nameN: faculty.namedotn,
          phone: faculty.phone,
          program,
          category
        }; // matches PersonInput in schema
        const labels = constructFacultyFields(value)
        options.push({
          id: labels?.id,
          title: labels?.title,
          value,
          // filterable fields
          category,
          academicPlan: program,  // used to filter faculty dropdowns by selected grad plan (faculty use program)
          program, // used to filter faculty dropdowns by the user's program
          proposedAcadPlan: program // used to filter faculty dropdowns by selected proposed grad plan (faculty use program)
        });
      }
    }
  }
  return sortBy(options, ["title"]);
}

export const constructPersonString = (person = {}) => {
  let personString = "";
  if(person?.firstName) personString += person.firstName;
  if(person?.lastName) personString += ` ${person.lastName}`;
  if(person?.emplid) personString += ` (${person.emplid})`;
  if(person?.nameN) personString += ` ${person.nameN}`;
  return personString;
}

export { formatDropdownSubtypeFromState, transformGraduateFacultyDropdownOptions };
